import React from "react";
import classNames from "classnames";
import "../assets/css/button.css";
export default function Button({ classes, text, onClick, type, ...rest }) {
  return (
    <button
      type={type ? type : ""}
      className={`main-button ${classNames(classes)}`}
      onClick={onClick}
      {...rest}
    >
      {text}
    </button>
  );
}
